import styled from "styled-components";

export const TabsSectionWrapper = styled.div`
  width: 100%;
  padding: 0 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.breakpoints.md.query} {
    padding: 0 24px;
  }
  ${({ theme }) => theme.breakpoints.sm.query} {
    padding: 0;
  }
`;

export const TabsSectionContainer = styled.div`
  background: ${({ theme }) => theme.colors.default[50]};
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: clip;
`;
